module.exports = __webpack_public_path__ + "img/profile3.6c7f5d96.png";